
import { defineComponent } from 'vue';
import { ITheme } from '@/types/models';
import utils from '@/utils';
import api from '@/api/my/templates';
import { auth } from '@/store';
import Deploy from './components/templates/Deploy.vue';
import Buy from './components/templates/Buy.vue';

interface IState {
  activeName: string;
  themes: ITheme[];
  orderResourceIds: string[];
  userName: string;
  isHostExists: boolean;
  theme: ITheme;
  isBuy: boolean;
  isDeploy: boolean;
  uploadToken: string;
  uploadUrl: string;
  isUpload: boolean;
}

export default defineComponent({
  components: {
    Deploy,
    Buy,
  },
  data() {
    return {
      activeName: 'my',
      themes: [],
      orderResourceIds: [],
      userName: '',
      isHostExists: false,
      theme: {} as ITheme,
      isBuy: false,
      isDeploy: false,
      uploadToken: auth.token,
      uploadUrl: api.getUploadUrl(),
      isUpload: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get({ type: this.activeName }, (res) => {
        this.themes = res.themes;
        this.orderResourceIds = res.orderResourceIds;
        this.userName = res.userName;
        this.isHostExists = res.isHostExists;
      });
    },

    apiDelete(theme: ITheme) {
      api.delete(
        {
          name: theme.name,
        },
        (res) => {
          if (!res) return;
          utils.success('模板删除成功！');
          this.apiGet();
        },
      );
    },

    getUrl(relatedUrl: string) {
      return `https://sscms.com/themes/${relatedUrl}`;
    },

    getDownloadUrl(theme: ITheme) {
      return `https://dl.sscms.com/themes/${theme.userName}/T_${theme.name}.zip`;
    },

    isAuthenticated(theme: ITheme) {
      if (theme.price > 0 && theme.userName !== this.userName) {
        return this.orderResourceIds.indexOf(theme.guid) !== -1;
      }
      return true;
    },

    btnTabsClick() {
      this.apiGet();
    },

    btnBuyClick(theme: ITheme) {
      this.theme = theme;
      this.isBuy = true;
    },

    btnDeployClick(args: { name: string; theme: ITheme }) {
      if (args.name === 'Buy') {
        utils.pageOpen(`/my/create/${args.theme.userName}-${args.theme.name}`);
      } else if (args.name === 'Deploy') {
        this.isDeploy = true;
        this.theme = args.theme;
      }
    },

    btnDownloadClick(theme: ITheme) {
      api.getTheme(
        {
          userName: theme.userName,
          name: theme.name,
        },
        (res) => {
          if (!res) return;
          window.open(res.themeDownloadUrl);
        },
      );
    },

    btnDeleteClick(theme: ITheme) {
      utils.alertDelete(
        {
          title: '删除模板',
          text: `此操作将删除模板 ${theme.name}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(theme);
        },
      );
    },

    btnUploadClick() {
      this.isUpload = true;
    },

    btnBuyCloseClick() {
      this.isBuy = false;
      this.apiGet();
    },

    uploadBefore(file: { name: string }) {
      const isZip = file.name.indexOf('.zip', file.name.length - '.zip'.length) !== -1;
      if (!isZip) {
        utils.error('模板文件只能是 Zip 格式!');
      }
      return isZip;
    },

    uploadProgress() {
      utils.loading(true);
    },

    uploadSuccess() {
      utils.success('模板上传成功！');
      this.isUpload = false;
      this.apiGet();
    },

    uploadError(err: { message: string }) {
      utils.loading(false);
      const error = JSON.parse(err.message);
      utils.error(error.message);
    },
  },
  mounted() {
    this.apiGet();
  },
});
